var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04193 2.29266C2.65117 2.15527 2.22301 2.36068 2.08563 2.75145C1.94824 3.14221 2.15365 3.57036 2.54442 3.70775L2.80562 3.79958C3.47323 4.0343 3.91199 4.18985 4.23483 4.34826C4.53806 4.49704 4.67173 4.61747 4.75978 4.74634C4.85005 4.87842 4.91975 5.05984 4.95908 5.42319C5.00023 5.8034 5.00125 6.29862 5.00125 7.03856L5.00125 9.64024H20.7254C21.056 7.9827 21.211 7.14067 20.7777 6.57733C20.3337 6.00024 18.817 6.00024 17.132 6.00024H6.4938C6.48711 5.72991 6.47442 5.48397 6.45037 5.26177C6.39664 4.76539 6.28022 4.31268 5.99824 3.90003C5.71406 3.48417 5.33621 3.21784 4.89558 3.00163C4.48349 2.79943 3.95986 2.61536 3.34333 2.39862L3.04193 2.29266Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.1999 12.1881L20.6997 9.76338L20.7242 9.64062H5C5 12.5822 5.06324 13.553 5.92964 14.4668C6.79604 15.3806 8.19049 15.3806 10.9794 15.3806H16.2823C17.8433 15.3806 18.6238 15.3806 19.1755 14.931C19.7273 14.4814 19.8848 13.717 20.1999 12.1881Z",
    fill: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z",
    fill: "#1C274C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartInactive);
export default __webpack_public_path__ + "static/media/cart-inactive.a42e4af9158f035ef5013299dfc76d45.svg";
export { ForwardRef as ReactComponent };